module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"columnsPersistentHead":["Site","Topic","Category","Status",""],"columnsPersistentTail":["Laptops",""]}}')
  delete Component.options._Ctor
}
